import React, { Component } from "react";
import { Container, Grid } from "@material-ui/core";
import IqacDescription from "./IqacDescription";
import "./iqac-sidebar.css";

const list = [
  {
    title: "About",
    link: "/iqac/about",
  },
  // {
  //   title: "Functions",
  //   link: "/iqac/functions",
  // },
  {
    title: "IQAC Committee",
    link: "/iqac/teams",
  },
  {
    title: "SSR",
    link: "/iqac/ssr",
  },
  {
    title: "AQAR",
    link: "/iqac/aqar",
  },
  {
    title: "Action Taken Report",
    link: "/iqac/atr",
  },
  {
    title: "Meeting Minutes",
    link: "/iqac/minutes",
  },
  {
    title: "Feedbacks",
    link: "/iqac/feedbacks",
  },
  {
    title: "IQAC Convenor / Coordinators",
    link: "/iqac/previosconvenor",
  },
  {
    title: "IQAC Assistant Coordinator",
    link: "/iqac/assistantcoordinator",
  },
  {
    title: "Feedbacks",
    link: "/iqac/feedbacks",
  },
  {
    title: "SOPs & Policies",
    link: "/iqac/sops",
  },
  {
    title: "MoUs & Collaborations",
    link: "/iqac/collaborations",
  },
   {
    title: "AISHE Certificates",
    link: "/iqac/aishe",
  },
  {
    title: "Notifications",
    link: "/iqac/notices",
  },
  {
    title: "Declaration",
    link: "/iqac/declaration",
  },
  {
    title: "Institutional Perspective Plan",
    link: "/iqac/institutional-perspective-plan",
  },

  {
    title: "Best Practices",
    link: "/iqac/best-practices",
  },

  {
    title: "Institutional Distinctiveness",
    link: "/iqac/institutional-distinctiveness",
  },
  {
    title: "Course Outcome & Program Outcome",
    link: "/iqac/iqac-co",
  },
  {
    title: "Seminars/Workshop/Webinars/Conferences",
    link: "/iqac/iqac-seminars",
  },
  {
    title: "Organogram",
    link: "/iqac/iqac-organogram",
  },
  {
    title: "Research Papers/Books/Edited Books/Book Chapters",
    link: "/iqac/research-papers",
  },
  {
    title: "Annual Reports",
    link: "/iqac/annual-reports",
  },
  {
    title: "Audit Statements",
    link: "/iqac/audit-statements",
  },
  
  // {
  //   title: "IIC",
  //   link: "/iqac/iic",
  // },
  // {
  //   title: "Feedback Forms",
  //   link: "/iqac/feedback",
  // },
  // {
  //   title: "Feedback Analysis",
  //   link: "/iqac/feedback-analysis",
  // },
  // {
  //   title: "Student Satisfactory Survey",
  //   link: "/iqac/sss",
  // },
  // {
  //   title: "Event / News",
  //   link: "/iqac/event-news",
  // },
  // {
  //   title: "Academic Calender",
  //   link: "/iqac/event-news",
  // },
];


class IqacComponent extends Component {
  state = {
    link: "",
    query: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    const query = this.state.query.trim().toLowerCase();
    const filtered = query
      ? list.filter((el) => el.title.toLowerCase().includes(query))
      : list;

    return (
      <div className="iqac-wrap">
        <Container>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <nav className="iqac-side">
                <div className="iqac-side-head">IQAC</div>
                <div className="iqac-search">
                  <div className="iqac-search-field">
                    <span className="fa fa-search" aria-hidden="true" />
                    <input
                      type="text"
                      className="iqac-search-input"
                      placeholder="Search IQAC menu..."
                      value={this.state.query}
                      onChange={(e) =>
                        this.setState({ query: e.target.value })
                      }
                    />
                  </div>
                </div>
                <ul className="iqac-side-list">
                  {filtered.length === 0 ? (
                    <li className="iqac-side-empty">No matching items</li>
                  ) : (
                    filtered.map((el, index) => (
                      <li
                        key={index}
                        className={`iqac-side-item${
                          el.link === `/iqac/${this.state.link}` ? " active" : ""
                        }`}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <span className="iqac-dot" />
                        {el.title}
                      </li>
                    ))
                  )}
                </ul>
              </nav>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9}>
              <IqacDescription type={this.state.link} />
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default IqacComponent;
